import equal from "fast-deep-equal";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ExclusivityConflictShowList, ScheduleConflictShowList } from "./ConflictingShowsList";
import { ExclusivityCheckFields, ExclusivityCheckResult, fetchExclusivityConflicts } from "./utils";
import { CustomSidePanel } from "components/SidePanel/CustomSidePanel";
import { SidePanelRef } from "components/SidePanel/SidePanel";

const emptyResult: ExclusivityCheckResult = {
  exclusivityCheckProblems: [],
  scheduleConflictProblems: [],
  exclusivityConflicts: [],
  scheduleConflicts: [],
};

interface Props {
  exclusivityCheckFields: ExclusivityCheckFields
}

export const ExclusivitySidePanel = (props: Props) => {
  const sidePanelRef = useRef<SidePanelRef>();
  const lastResultRef = useRef<ExclusivityCheckResult>(emptyResult);
  const [stableFields, setStableFields] = useState(props.exclusivityCheckFields);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!equal(props.exclusivityCheckFields, stableFields)) {
      setStableFields(props.exclusivityCheckFields);
      setEnabled(true);
    }
  }, [props.exclusivityCheckFields]);

  const { data } = useQuery(
    ["exclusivity-conflicts", stableFields],
    ({ queryKey }) => fetchExclusivityConflicts(queryKey[1] as ExclusivityCheckFields, site.userPreference.display.displayScheduleConflicts, lastResultRef.current),
    { keepPreviousData: true, initialData: emptyResult, enabled }
  );

  useEffect(() => {
    lastResultRef.current = data;

    if (data.exclusivityConflicts.length > 0 || data.scheduleConflicts.length > 0) {
      sidePanelRef.current.open();
    }
  }, [data]);

  return <CustomSidePanel
    ref={sidePanelRef}
    trigger={null}
    id="exclusivity-check"
    size="medium"
    title={RESX.Exclusivity.resxConflicts}
  >
    <ExclusivityConflictShowList
      conflictingShows={data.exclusivityConflicts}
      startDisplay={moment.utc(stableFields.showStartDisplay)}
      noConflictsLabel={RESX.Exclusivity.NoConflicts}
      problems={data.exclusivityCheckProblems}
    />

    {site.userPreference.display.displayScheduleConflicts && <ScheduleConflictShowList
      conflictingShows={data.scheduleConflicts}
      startDisplay={moment.utc(stableFields.showStartDisplay)}
      noConflictsLabel={RESX.Exclusivity.NoScheduleConflicts}
      problems={data.scheduleConflictProblems}
    />}
  </CustomSidePanel>
}